<template>
	<view class="wallet-page">
		<view :style="{ height: statusbarHeight + 'px' }"></view>
		<view class="header">
			<text class="title">门店钱包</text>
		</view>
		<view class="content">
			<text>钱包页面</text>
		</view>
		<custom-tabbar></custom-tabbar>
	</view>
</template>

<script>
	import { mapState } from 'vuex'
	import CustomTabbar from '@/components/custom-tabbar/custom-tabbar.vue'

	export default {
		components: {
			CustomTabbar
		},
		computed: {
			...mapState(['statusbarHeight'])
		}
	}
</script>

<style lang="scss" scoped>
	.wallet-page {
		min-height: 100vh;
		background: #f8f8f8;
	}
	.header {
		padding: 30rpx;
		.title {
			font-size: 40rpx;
			font-weight: 600;
		}
	}
	.content {
		padding: 30rpx;
	}
</style>
